"use strict";

/**
 * @classdesc
 * Speichern-Panel des Digitalisierungs-Moduls.
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCDigitize
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCDigitize} options.module Modul-Instanz
 */
gc.gis.module.GCDigitize.SavePanel = function(options)
{
	gc.gis.assert.isSet(options);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCDigitize);

	/**
	 * @type {gc.gis.module.GCDigitize}
	 * @private
	 */
	this._module = options.module;
	/**
	 * Speichern-Button (siehe _initActionbar());
	 * @type {gc.gis.widget.GCItem}
	 */
	this._btn_save = null;

	var options_widget = {
		className: 'gc-digitize',
		actionbar: this._initActionbar()
	};

    gc.gis.widget.GCPanel.call(this, options_widget);

	// Inhalt erzeugen
    this.element = this._render();
    this._initContent();
    this._initEvents();
};
gc.gis.module.GCDigitize.SavePanel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 * Initialisiert den Panel-Inhalt
 *
 * @protected
 * @method
 */
gc.gis.module.GCDigitize.SavePanel.prototype._initContent = function()
{
	var self = this;

	var form_config = {
		className: 'form-featureinfo',
		controls: [
			{
				label: 'Ebene zur Speicherung auswählen',
				name: 'layer',
				type: 'select',
				options: [],
				change: function(evt, control)
				{
					var geomCountValues = self._module.countGeometryTypes(self._module.getLayer().getFeatures());
					self._updateForm
					(
						geomCountValues[gc.gis.geom.GCGeometryType.POINT],
						geomCountValues[gc.gis.geom.GCGeometryType.LINESTRING],
						geomCountValues[gc.gis.geom.GCGeometryType.POLYGON]
					);
				},
				initFunc: function (control)
				{
					self._module.map.on(gc.gis.map.GCMapEvent.LAYER_ADDED, self, function (evt) {
						control.updateOptions(control.updateFunc.call(this));
					});
					self._module.map.on(gc.gis.map.GCMapEvent.LAYER_REMOVED, self, function (evt) {
						control.updateOptions(control.updateFunc.call(this));
					});
				},
				updateFunc: function () {
					// TODO: Rechteprüfung, hat der Nutzer Schreibrechte für die Fachdaten des Layers?
					var options = [];
					var layers = self._module.map.getLayersRecursive(function(layer) {
						return layer.getType() === gc.gis.layer.GCLayerType.FACHDB;
					});
					for (var i = layers.length-1; i>=0; i--)
					{
						options.push({
							value: layers[i].getConfig().name,
							label: layers[i].getLabel()
						});
					}
					return options;
				}
			},
			{
				label: 'Speichern unter',
				name: 'method',
				type: 'select',
				options: [
					{
						label: 'neuem Fachobjekt',
						value: gc.gis.module.GCDigitizeConstants.SAVE_NEW_SINGLE
					},
					{
						label: 'neuem Fachobjekt pro Koordinatenobjekt',
						value: gc.gis.module.GCDigitizeConstants.SAVE_NEW_MULTI
					}
					// TODO implementieren
					/*,
					{
						label: 'neuem Koordinatenobjekt an aktuellem Fachobjekt (anhängen)',
						value: gc.gis.module.GCDigitizeConstants.SAVE_APPEND
					},
					{
						label: 'aktuellem Koordinatenobjekt (überschreiben)',
						value: gc.gis.module.GCDigitizeConstants.SAVE_OVERWRITE
					}
					//*/
				]
			},
			{
				label: 'P',
				name: 'save_point',
				type: 'checkbox',
				tooltip: 'automatisch deaktiviert, wenn der gewählte Layer keine Punktobjekte unterstützt oder keine Punktobjekte eingezeichnet wurden'
			},
			{
				label: 'L',
				name: 'save_line',
				type: 'checkbox',
				tooltip: 'automatisch deaktiviert, wenn der gewählte Layer keine Linienobjekte unterstützt oder keine Linienobjekte eingezeichnet wurden'
			},
			{
				label: 'F',
				name: 'save_polygon',
				type: 'checkbox',
				tooltip: 'automatisch deaktiviert, wenn der gewählte Layer keine Flächenobjekte unterstützt oder keine Flächenobjekte eingezeichnet wurden'
			},
			{
				label: 'Bezeichnung',
				name: 'name',
				type: 'text'
			}
		],
		validate: function(form, params)
		{
			if(!params.save_point && !params.save_line && !params.save_polygon)
			{
				throw new gc.gis.error.GCError('Es wurden keine Objekte zur Speicherung ausgewählt.');
			}
			if(!params.layer)
			{
				throw new gc.gis.error.GCError('Es steht keine Ebene zur Speicherung zur Verfügung. Laden Sie eine Ebene mit Schreibberechtigungen.');
			}
		},
		submit: function(form, params)
		{
			self._onSave(params);
		}
	};

	this._form = gc.gis.util.GCFormRenderer.renderForm(form_config);
	this.element_content.append(this._form.getElement());

	this._updateForm(0, 0, 0);
	this._updateMethodOptions(-1, -1);
};

/**
 * Initialisiert die Eventbehandlungsroutinen des Panels.
 *
 * @private
 */
gc.gis.module.GCDigitize.SavePanel.prototype._initEvents = function()
{
	this._module.on(gc.gis.module.GCDigitizeEvent.FEATURE_ADDED, this, function(evt) {
		this._updateForm(
			evt[gc.gis.geom.GCGeometryType.POINT],
			evt[gc.gis.geom.GCGeometryType.LINESTRING],
			evt[gc.gis.geom.GCGeometryType.POLYGON]
		);
	});
	this._module.on(gc.gis.module.GCDigitizeEvent.FEATURE_REMOVED, this, function(evt) {
		this._updateForm(
			evt[gc.gis.geom.GCGeometryType.POINT],
			evt[gc.gis.geom.GCGeometryType.LINESTRING],
			evt[gc.gis.geom.GCGeometryType.POLYGON]
		);
	});
	this._module.on(gc.gis.module.GCDigitizeEvent.LAYER_CLEARED, this, function(evt) {
		this._updateForm(
			evt[gc.gis.geom.GCGeometryType.POINT],
			evt[gc.gis.geom.GCGeometryType.LINESTRING],
			evt[gc.gis.geom.GCGeometryType.POLYGON]
		);
	});

	this._module.on(gc.gis.module.GCDigitizeEvent.EDITOR_FEATURE_OPENED, this, function(evt) {
		this._updateMethodOptions(
			evt.fac_id,
			evt.koord_id
		);
	});
};

/**
 * Initialisiert die Actionbar.
 *
 * @method
 * @return {Object}
 * @private
 */
gc.gis.module.GCDigitize.SavePanel.prototype._initActionbar = function()
{
	var self = this;

	this._btn_save = new gc.gis.widget.GCItem({
		label: 'Speichern',
		className: 'btn btn-success',
		icon: 'action-apply',
		click: function(evt) {
			try
			{
				if (self._btn_save.isEnabled())
				{
					self._form.submit();
					gc.gis.iface.ui.sidebar.historyBack();
				}
			}
			catch(err)
			{
				gc.gis.iface.log.error(self, err);
			}
		}
	});

	var btn_cancel = new gc.gis.widget.GCItem({
		label: 'Abbrechen',
		className: 'btn btn-primary',
		click: function(evt) {
			try
			{
				gc.gis.iface.ui.sidebar.historyBack();
			}
			catch(err)
			{
				gc.gis.iface.log.error(self, err);
			}
		}
	});

	return new gc.gis.widget.GCMenu({
		containerClassName: 'actionbar',
		items: [
			this._btn_save,
			btn_cancel
		]
	})
};

/**
 * Ereignisbehandlungsroutine die zum Speichern der Objekte aufgerufen wird.
 *
 * @private
 */
gc.gis.module.GCDigitize.SavePanel.prototype._onSave = function(params)
{
	var layer = this._module.map.getLayersRecursive(function (layer) {
		return layer instanceof gc.gis.layer.GCLayer
			&& layer.getType() === gc.gis.layer.GCLayerType.FACHDB
			&& layer.getName() === params.layer;
	});
	var method = parseInt(params.method || gc.gis.module.GCDigitizeConstants.SAVE_NEW_SINGLE);
	var geometry_types = [];

	if (params.save_point)
	{
		geometry_types.push(gc.gis.geom.GCGeometryType.POINT);
	}
	if (params.save_line)
	{
		geometry_types.push(gc.gis.geom.GCGeometryType.LINESTRING);
	}
	if (params.save_polygon)
	{
		geometry_types.push(gc.gis.geom.GCGeometryType.POLYGON);
	}

	if (layer.length !== 1)
	{
		throw new gc.gis.error.GCError(this, 'Ebene zur Speicherung konnte nicht ermittelt werden.');
	}

	this._module.save(layer[0], method, geometry_types, params.name);
};

/**
 * Ereignisbehandlungsroutine die bei Änderungen an der Zeichenebene aufgerufen wird.
 *
 * @param {int} numPoints
 * @param {int} numLines
 * @param {int} numPolygons
 * @private
 */
gc.gis.module.GCDigitize.SavePanel.prototype._updateForm = function(numPoints, numLines, numPolygons)
{
	var pointCheck = numPoints > 0;
	var lineCheck = numLines > 0;
	var polygonCheck = numPolygons > 0;

	var selectedLayerName = this._form.getValue('layer');
	if (selectedLayerName)
	{
		var layers = this._module.map.getLayersRecursive(function(layer)
		{
			return layer.getType() === gc.gis.layer.GCLayerType.FACHDB &&
				layer.getName() === selectedLayerName;
		});

		if (layers.length === 1)
		{
			var allowedGeometryTypes = layers[0].getConfig('allowedGeometryTypes');

			if (allowedGeometryTypes instanceof Array)
			{
				pointCheck = pointCheck && allowedGeometryTypes.includes(gc.gis.geom.GCGeometryType.POINT);
				lineCheck = lineCheck && allowedGeometryTypes.includes(gc.gis.geom.GCGeometryType.LINESTRING);
				polygonCheck = polygonCheck && allowedGeometryTypes.includes(gc.gis.geom.GCGeometryType.POLYGON);
			}
		}
	}

	this._form.setValue('save_point', pointCheck);
	this._form.setValue('save_line', lineCheck);
	this._form.setValue('save_polygon', polygonCheck);

	this._form.setLabel('save_point', numPoints + ' Punktobjekte');
	this._form.setLabel('save_line', numLines + ' Linienobjekte');
	this._form.setLabel('save_polygon', numPolygons + ' Flächenobjekte');

	pointCheck ? this._form.enable('save_point') : this._form.disable('save_point');
	lineCheck ? this._form.enable('save_line') : this._form.disable('save_line');
	polygonCheck ? this._form.enable('save_polygon') : this._form.disable('save_polygon');

	this._btn_save.setEnabled(pointCheck || lineCheck || polygonCheck);
};


/**
 * Ereignisbehandlungsroutine die beim Empfangen einer ID eines Fachobjekts oder eines Koordinatenobjekts aufgerufen wird.
 *
 * @param {int} fac_id
 * @param {int} koord_id
 * @private
 */
gc.gis.module.GCDigitize.SavePanel.prototype._updateMethodOptions = function(fac_id, koord_id)
{
	if (fac_id > 0)
	{
		this._form.enableSelectOption('method', String(gc.gis.module.GCDigitizeConstants.SAVE_APPEND));
	}
	else
	{
		this._form.disableSelectOption('method', String(gc.gis.module.GCDigitizeConstants.SAVE_APPEND));
	}

	if (fac_id > 0 && koord_id > 0)
	{
		this._form.enableSelectOption('method', String(gc.gis.module.GCDigitizeConstants.SAVE_OVERWRITE));
	}
	else
	{
		this._form.disableSelectOption('method', String(gc.gis.module.GCDigitizeConstants.SAVE_OVERWRITE));
	}
};
